<template>
  <div class="page-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="deposit-warp">
        <div class="join-status">{{ detail.statusTxt }}</div>
        <!--        <div class="join-tip">{{ detail.name }}提交的{{ detail.joinMethodTxt }}</div>-->
        <!--        <div class="join-time">申请时间：{{ detail.applyTime }}</div>-->
        <img
          class="join-icon"
          :src="`https://x.jzbull.com/x_dsx_h5admin/market/deposit/${depositStatus[detail.status]}.png`"
          alt=""
        />
      </div>

      <div class="deposit-position">
        <div class="join-content">
          <van-cell-group inset>
            <div class="join-info">
              <img class="join-head" :src="detail.avaterUrl || defaultAvatar" alt="" />
              <div class="join-user">
                <div class="join-nickname clamp-1">{{ detail.nickname }}</div>
                <!--               <span class="join-id">(ID:{{ detail.puid }})</span>-->
                <div class="join-mobile">{{ detail.mobile }}</div>
              </div>
            </div>
            <van-cell title="用户类型" :value="detail.level" />
            <van-cell title="充值金额" :value="'￥' + detail.amount" />
            <van-cell title="充值账户" :value="detail.account" />
            <van-cell title="业务单号" :value="detail.orderSn">
              <template #right-icon>
                <span class="join-copy" @click.stop="copyLink(detail.orderSn)">复制</span>
              </template>
            </van-cell>
            <van-cell title="充值方式" :value="detail.payway" />
            <van-cell title="充值备注" :value="detail.remark" />
            <div class="join-cell">
              <div class="join-title">充值凭证</div>
              <div class="join-pics" v-if="detail.picContent?.length > 0">
                <img
                  class="join-pic"
                  v-for="(item, index) in detail.picContent"
                  :key="index"
                  :src="item"
                  alt=""
                  @click="toPreview(index)"
                />
              </div>
              <div class="join-pics-empty" v-else>客户未上传充值凭证</div>
            </div>
          </van-cell-group>
        </div>
        <div class="join-content">
          <van-cell-group inset>
            <van-cell title="审核结果" :value="detail.statusTxt" />
            <van-cell title="审核时间" :value="detail.auditDate" />
            <van-cell title="审核人员" :value="detail.auditName" />
            <van-cell title="审核备注" :value="detail.auditRemark" />
          </van-cell-group>
        </div>
      </div>

      <div class="foot" v-if="detail.status == 0">
        <div class="button-list">
          <div class="button" @click="audit">审核</div>
        </div>
      </div>
    </van-pull-refresh>
    <AuditModal
      :show="showAudit"
      :auditForm="auditForm"
      :auditInfo="auditInfo"
      @cancel="auditCancel"
      @confirm="auditConfirm"
    />
  </div>
</template>
<script setup>
import { reactive, onMounted, ref, unref, computed } from 'vue'
import { showToast, showSuccessToast, showImagePreview } from 'vant'
import { getDepositOrderDetailApi, depositAuditApi } from '@/api/yck'
import { AuditModal } from './components/'
import { useRoute } from 'vue-router'
const { query } = useRoute()
import usePage from '@/hooks/usePage'
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard'
const { navigateTo } = usePage()
const ajaxing = ref(false)
const refreshing = ref(false)
const orderId = query.id || 0
const joinMethod = ref(0) //加盟方式 1-购买加盟商品 2-邀请加盟 3=主动申请  0=全部
const showAudit = ref(false)
const remark = ref('')
const result = ref(2)
const defaultAvatar = ref('https://x.jzbull.com/x_dsx_wxadmin/default-head.png')

let detail = ref({
  orderId: 0
})
const tabList = ref([
  { text: '待审核', status: 1 },
  { text: '已同意', status: 2 },
  { text: '已拒绝', status: 3 },
  { text: '全部', status: 0 }
])
const tabIndex = ref(0)
//status 审核状态 1-待审核 2-已同意 3-已拒绝 4-已作废
const auditInfo = reactive({
  type: 'one',
  fullName: '',
  mobile: ''
})
const auditForm = reactive({
  orderId: orderId,
  status: '1',
  remark: ''
})

const depositStatus = ref({
  0: 'audit',
  1: 'success',
  2: 'refuse'
})
//status 审核状态 1-待审核 2-已同意 3-已拒绝 4-已作废

const { clipboardRef, copiedRef } = useCopyToClipboard()

const copyLink = orderSn => {
  clipboardRef.value = orderSn
  unref(copiedRef) && showSuccessToast('复制成功')
}
const onRefresh = () => {
  getDepositAuthDetail()
}

const getDepositAuthDetail = async () => {
  if (ajaxing.value) return
  ajaxing.value = true
  detail.value = await getDepositOrderDetailApi({ orderId })
  ajaxing.value = false
  refreshing.value = false
}
const audit = params => {
  showAudit.value = true
  auditInfo.type = 'one'
  auditForm.orderId = orderId
}

const auditCancel = () => {
  showAudit.value = false
  auditForm.orderId = 0
  auditForm.status = '1'
  auditForm.remark = ''
}
const auditConfirm = async () => {
  if (auditForm.status == 0) {
    showToast('请选择通过/作废选项')
    return
  }
  auditForm.status = parseInt(auditForm.status, 10)
  await depositAuditApi(auditForm)
  showToast('审核成功')
  showAudit.value = false
  auditCancel()
  await getDepositAuthDetail()
}

function toPreview(index) {
  showImagePreview({ images: detail.value.picContent, startPosition: index })
}

onMounted(async () => {
  await getDepositAuthDetail()
})
</script>
<style lang="less" scoped>
.page-container {
  width: 100vw;
  // overflow: hidden;
  height: 100%;
  padding-bottom: 88px;
}

:deep(.van-cell__value) {
  color: #222222;
}
:deep(.van-cell__title) {
  flex: none;
  width: 100px !important;
}

.popBox {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.popBottom {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.contentPopBox {
  position: relative;
  width: 75%;
  min-height: 240px;
  padding-top: 16px;
  padding-bottom: 16px;
  box-sizing: border-box;
  border-radius: 10px;
  background: #fff;

  .poptitle {
    font-size: 18px;
    color: #222222;
    line-height: 24px;
    font-weight: 500;
  }

  .borderdiv {
    border: 1px solid #eee;
    width: 280px;
    height: 84px;
    overflow: hidden;
    background: #fff;
    margin: 0 auto 28px;
  }

  .pop-btn-box {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 16px;
    box-sizing: border-box;
    padding: 0 30px;
  }

  .btntwo {
    width: 124px;
    height: 40px;
  }

  .btnListSpecial {
    margin-left: 12px;
  }

  .poplable {
    font-size: 14px;
    color: #222222;
    line-height: 20px;
    margin: 0 20px 20px;
  }

  .cha {
    display: none;
    position: absolute;
    right: 12px;
    top: 20px;
    width: 24px;
    height: 24px;
  }
}

.audit-radio {
  justify-content: space-around;
}

.pop-content {
  padding: 16px 30px 30px;

  .audit-info {
    font-size: 14px;
    color: #222222;

    .audit-id {
      color: #999999;
    }
  }

  .audit-tip {
    font-size: 14px;
    color: #222222;
  }
}

.audit-textarea {
  padding: 0;
  margin: 12px 0 20px;
  min-height: 32px;
  border: 1px solid rgba(216, 216, 216, 0.5);
}

.foot {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  box-sizing: border-box;
  height: 56px;
  line-height: 56px;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background-color: #fff;

  .foot__it {
    flex: 1;
    display: flex;
    align-items: center;

    .foot-all {
      font-size: 16px;
      color: #222222;
      margin-left: 8px;
    }
  }
}

.button-list {
  flex: 1;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;

  .button {
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: linear-gradient(170deg, #ffb695 0%, #fd7f5c 100%);
    text-align: center;
    color: #ffffff;
    border-radius: 20px;
  }

  .small-button {
    width: 96px;
    height: 40px;
    line-height: 40px;
    background: #ff6060;
    text-align: center;
    color: #ffffff;
  }

  .small-button--cancel {
    opacity: 0.2;
    background: #999999;
    color: #ccc;
    margin-right: 8px;
  }
}

.van-cell-group--inset {
  margin: 0 12px;
}

.deposit-warp {
  position: relative;
  width: 100%;
  height: 184px;
  padding: 16px;
  background: url('https://x.jzbull.com/x_dsx_h5admin/market/deposit/deposit-bg.png') no-repeat;
  background-size: 100%;
  background-color: #ff6060;

  .join-status {
    font-size: 20px;
    color: #ffffff;
    font-weight: bold;
    padding-bottom: 4px;
    padding-top: 30px;
  }

  .join-time {
    font-size: 14px;
    color: #999999;
  }

  .join-icon {
    position: absolute;
    right: 20px;
    top: 24px;
    width: 80px;
    height: 80px;
  }

  .join-tip {
    font-size: 14px;
    color: #666666;
    padding-bottom: 4px;
  }
}

.deposit-position {
  position: relative;
  top: -80px;
}

.join-content {
  margin-top: 12px;

  .join-info {
    display: flex;
    align-items: center;
    padding: 16px 0;
    margin: 0 12px;
    border-bottom: 0.5px solid rgba(219, 219, 219, 0.5);
    //background: rgba(219,219,219,0.50);
    .join-head {
      width: 48px;
      height: 48px;
      border-radius: 50%;
    }

    .join-user {
      margin-left: 12px;

      .join-nickname {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #222222;
      }

      .join-id {
        font-size: 14px;
        margin-left: 8px;
      }

      .join-mobile {
        font-size: 14px;
        color: #999999;
        margin-top: 4px;
      }
    }
  }

  .join-cell {
    padding: 16px 0;
    margin: 0 12px;
    background-color: #fff;

    .join-title {
      font-size: 14px;
      color: #222222;
      margin-bottom: 12px;
    }
  }

  .join-pics {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .join-pic {
      width: 73px;
      height: 73px;
      margin-right: 8px;
    }
  }

  .join-pics-empty {
    font-size: 14px;
    color: #666666;
  }

  .join-remark {
    background: rgba(216, 216, 216, 0.2);
    font-size: 12px;
    color: #999999;
    line-height: 22px;
    padding: 12px;
  }
}

.join-copy {
  font-size: 12px;
  color: #ff6060;
}
</style>
